/** Illustrative forklift shared-space example. Not a restricted-area measurement. */
export const SHOWCASE_SCAN_PDF_PATH = '/showcase-assets/Edgentik_Safety_Control_Scan_Final.pdf';
export const SHOWCASE_VERIFY_FOOTER_BADGE = 'VERIFY · ILLUSTRATIVE CUSTOMER EXAMPLE';
export const SHOWCASE_VERIFY_FOOTER_NOTE = 'Separate completed example — not calculated from the recorded demo above.';
export const SHOWCASE_VERIFY_FOOTER_BEFORE = '0.35 / h';
export const SHOWCASE_VERIFY_FOOTER_CONTROL = 'Fixed barrier + timing + markings';
export const SHOWCASE_VERIFY_FOOTER_AFTER = '0.18 / h';
export const SHOWCASE_VERIFY_FOOTER_REDUCTION = '49% LOWER OBSERVED RATE';
export const SHOWCASE_SCAN_CTA = 'View completed Safety Control Scan →';
